<div class="w-full max-w-5xl px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
    <!-- Heading -->
    <div class="prose prose-sm !max-w-none">
        <h2 class="m-0" id="documents-heading">{{ 'label_paycheck_runs_for_printout' | translate }}</h2>
        <p class="m-0 text-secondary">{{ 'info_paycheck_runs_for_printout' | translate }}</p>
    </div>

    <!-- Filters -->
    <div id="header" class="mt-6 border-b pb-6">
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <div class="mt-4 grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6 items-center">
                <!-- Left side: inputs -->
                <div class="lg:col-span-10 flex flex-col gap-3">
                    <!-- Search -->
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input matInput [placeholder]="'Leita'" formControlName="searchString" (keydown.enter)="search()" />
                    </mat-form-field>

                    <!-- Date range row -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <span class="mr-4" matPrefix>Frá:</span>
                            <input
                                class="date"
                                formControlName="dateFrom"
                                matInput
                                placeholder="Dagsetning (frá)"
                                (click)="dateFrom.open()"
                                [matDatepicker]="dateFrom"
                            />
                            <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                            <mat-datepicker #dateFrom></mat-datepicker>
                            @if (this.form?.get('dateFrom')?.hasError('required')) {
                                <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field class="fuse-mat-no-subscript w-full">
                            <span class="mr-4" matPrefix>Til:</span>
                            <input
                                class="date"
                                formControlName="dateTo"
                                matInput
                                placeholder="Dagsetning (til)"
                                (click)="dateTo.open()"
                                [matDatepicker]="dateTo"
                            />
                            <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                            <mat-datepicker #dateTo></mat-datepicker>
                            @if (this.form?.get('dateTo')?.hasError('required')) {
                                <mat-error> Það <strong>þarf</strong> að velja dagsetningu </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>

                <!-- Right side: button -->
                <div class="lg:col-span-2">
                    <button class="w-full lg:w-full min-w-[140px]" mat-flat-button [color]="'primary'" (click)="search()">
                        <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <span class="ml-2 mr-1">{{ 'label_search' | translate }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>

    <!-- Table + paginator -->
    <ng-container>
        <div class="mt-6">
            <div class="w-full overflow-x-auto">
                <table mat-table matSort [dataSource]="dataSource" class="min-w-[760px] w-full table-expandable">
                    <ng-container matColumnDef="registeredOn">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'label_recorded' | translate }}</th>
                        <td mat-cell *matCellDef="let r">
                            {{ r.registeredOn | date: 'dd.MM.yyyy' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="paycheckRunId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'label_run' | translate }}</th>
                        <td mat-cell *matCellDef="let r">
                            {{ r.paycheckRunId }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'label_title' | translate }}</th>
                        <td mat-cell *matCellDef="let r" class="max-w-[420px] truncate">
                            {{ r.title }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="printableCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fjöldi launaseðla</th>
                        <td class="text-center" mat-cell *matCellDef="let r">
                            {{ r.printableCount }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let r" class="whitespace-nowrap">
                            <button mat-stroked-button color="primary" (click)="openPostalPrint(r)">
                                {{ 'label_get_paychecks' | translate }}
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
                </table>
            </div>

            <div>
                <mat-paginator
                    #paginator
                    [length]="totalData"
                    [pageSizeOptions]="pageSizes"
                    [pageSize]="pageSize"
                    (page)="pageChanged($event)"
                    showFirstLastButtons
                >
                </mat-paginator>
            </div>
        </div>

        <!-- Empty state -->
        @if (totalData == 0 && !isLoading) {
            <div class="flex flex-col items-center justify-center py-12 sm:py-20">
                <div class="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight leading-tight text-center">
                    {{ 'label_no_paycheck_runs_found' | translate }}
                </div>
                <div class="mt-3 text-base sm:text-lg md:text-xl font-medium tracking-tight text-center text-secondary">
                    {{ 'info_no_paycheck_runs_found' | translate }}
                </div>
            </div>
        }
    </ng-container>
</div>
